import wx from 'weixin-js-sdk' // 引入微信SDK
import Vue from 'vue'
import store from '../store'

// 向后端请求权限验证配置的基本数据
function getSignUrl() {
  return location.href.split('#')[0]
}
function sign(param) {
  Vue.prototype.$https
    .getWXConfig({
      schoolId: store.state.schoolId,
      url: getSignUrl(),
    })
    .then((res) => {
      console.log('数据---------', res.data)
      initAPIs(res.data, param)
    })
}

const jsApiList = [
  'checkJsApi', //检测接口权限
  'updateTimelineShareData', //1.4.0的分享接口，注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
  'updateAppMessageShareData', //1.4.0的分享接口,注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
  'onMenuShareAppMessage', //老版本分享接口。
  'onMenuShareTimeline', //老版本分享接口。
  'getLocation',
]

function initAPIs(data, param) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.nonceStr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名
    jsApiList: jsApiList, // 必填，需要使用的JS接口列表
  })
  // 验证成功后执行的方法
  wx.ready(function () {
    // if (commFunc.isNotEmpty(param.callback)) {
    // console.log(param.callback)
    console.log('分享ready')
    share(param)
    // }
  })
  wx.error(function (res) {
    console.log('配置失败', res)
  })
  // 判断客户端是否支持指定js的接口
  wx.checkJsApi({
    jsApiList: jsApiList,
    success: function (res) {
      // return res
      console.log('判断客户端支持js接口', res)
    },
  })
}

// 页面调用分享功能的方法
export function init(param) {
  if (!param) {
    return
  }
  sign(param)
}

// 分享内容填充和调用分享方法
export function share(param) {
  var title = param.title
  var imgUrl = param.imgUrl
  var description = param.description
  var url = param.url
  var successMethod = param.successMethod
  var tempParam = {
    title: title,
    desc: description,
    link: url,
    imgUrl: imgUrl,
    success: (res) => {
      console.log(res)
      // param.callBack && param.callBack(res)
    },
    cancel: function (res) {
      console.log('分享失败', res)
    },
  }
  // //分享给朋友
  wx.onMenuShareAppMessage(tempParam)
  // //分享给朋友圈
  wx.onMenuShareTimeline(tempParam)
  // // 分享给朋友
  wx.updateAppMessageShareData(tempParam)
  wx.updateTimelineShareData(tempParam)
}
